// extracted by mini-css-extract-plugin
export default {"mainBox":"style_mainBox__14upv","contentBox":"style_contentBox__OfE-6","listBox":"style_listBox__G9DoC"};